import * as React from "react";

const TickBox = (props) => (
  <svg
    width={26}
    height={27}
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon">
      <rect width={17} height={18} transform="scale(1.5)" fill="#4295E4" />
      <path
        id="Icon_2"
        opacity={0.9}
        d="M10.0781 17.8115L6.16406 13.9005C6.05469 13.7906 6 13.6492 6 13.4764C6 13.3037 6.05469 13.1623 6.16406 13.0524L7.03125 12.2042C7.14063 12.0785 7.27734 12.0157 7.44141 12.0157C7.60547 12.0157 7.75 12.0785 7.875 12.2042L10.5 14.8429L16.125 9.18848C16.25 9.06283 16.3945 9 16.5586 9C16.7227 9 16.8594 9.06283 16.9688 9.18848L17.8359 10.0366C17.9453 10.1466 18 10.288 18 10.4607C18 10.6335 17.9453 10.7749 17.8359 10.8848L10.9219 17.8115C10.8125 17.9372 10.6719 18 10.5 18C10.3281 18 10.1875 17.9372 10.0781 17.8115Z"
        fill="white"
      />
    </g>
  </svg>
)
export default TickBox;